import { inventoryApi } from './api/inventory';
import { loyaltyApi } from './api/loyalty';
import { customerCareApi } from './api/customerCare';
import type { ApiProxyClient } from './types';
import { discountsApi } from './api/discounts';
import { identityApi } from './api/identity';
import { cartApi } from './api/cart';
import { ordersApi } from './api/orders';

/**
 * @deprecated Use v2 client instead
 *
 *
 * This function is deprecated and will be removed in future releases.
 *
 * @example
 * // Old usage:
 * import apiProxyClient from '@libs/api-proxy-client'
 * apiProxyClient.loyalty.getOffers();
 *
 * // New usage:
 * import { getOffers } from '@libs/api-proxy-client/v2'
 * getOffers();
 */
const apiProxyClient: ApiProxyClient = {
    cart: cartApi,
    customerCare: customerCareApi,
    discounts: discountsApi,
    identity: identityApi,
    inventory: inventoryApi,
    loyalty: loyaltyApi,
    orders: ordersApi,
};

export default apiProxyClient;
export * from './types';
export * from './utils';
